import polyglotI18nProvider from "ra-i18n-polyglot";
import Layout from "./layout/Layout";
import Login from "./layout/Login";
import { Admin, Resource } from "react-admin";
import * as React from "react";
import themeReducer from "./themeReducer";
import categories from "./resources/categories";
import backgroundModules from "./resources/backgroundModules";
import backgroundPlaylists from "./resources/backgroundPlaylists";
import communicationPages from "./resources/communicationPages";
import communicationFlows from "./resources/communicationFlows";
import contentTypes from "./resources/contentTypes";
import subContentTypes from "./resources/subContentTypes";
import modules from "./resources/modules";
import objectives from "./resources/objectives";
import plans from "./resources/plans";
import playlists from "./resources/playlists";
import listsSingles from "./resources/listsSingles";
import subscriptions from "./resources/subscriptions";
import users from "./resources/users";
import smsLogs from "./resources/smsLogs";
import promoCodes from "./resources/promoCodes";
import premiumAccess from "./resources/premiumAccess";
import userSuggestions from "./resources/userSuggestions";
import reminders from "./resources/reminders";
import members from "./resources/members";
import dayPortions from "./resources/dayPortions";
import doctors from "./resources/doctors";
import tasks from "./resources/tasks";
import moodTracker from "./resources/moodTracker";
import businesses from "./resources/businesses";
import surveys from "./resources/surveys";
import licenses from "./resources/licenses";
import badges from "./resources/badges";
import timelines from "./resources/timelines";
import journals from "./resources/journals";
import hrResourcesCategories from "./resources/hrResourcesCategories";
import hrResourcesContent from "./resources/hrResourcesContent";
import products from "./resources/products";
import demoRequests from "./resources/demoRequests";

import Dashboard from "./pages/Dashboard";
import NotFound from "./pages/NotFound";

import customRoutes from "./pages/customRoutes";
import { envSettings } from "./settings/env";

import authProvider from "./providers/authProvider";
import DataProvider from "./providers/dataProvider";
import {
    CustomEnglishMessages,
    englishMessages,
} from "./providers/translationProvider";

import { userPreferences } from "./utils/fakeUserPrefrences";
import dailyRecommendationsArabic from "./resources/dailyRecommendationsArabic";
import dailyRecommendationsEnglish from "./resources/dailyRecommendationsEnglish";
import featuredArabic from "./resources/featuredArabic";
import featuredEnglish from "./resources/featuredEnglish";

import { rolesGlobal } from "./utils/constants";

const messages = {
    en: { ...englishMessages, ...CustomEnglishMessages },
};

const i18nProvider = polyglotI18nProvider(
    () => messages[userPreferences.displayLanguage],
    "en",
    {
        allowMissing: true,
    }
);

const dataProvider = DataProvider(envSettings.baseUrl);

const getResourceProps = (resourceDefinition, isCoach) => {
    if (isCoach && resourceDefinition) {
        const { create, edit, ...readOnlyDefinition } = resourceDefinition;
        return readOnlyDefinition;
    }
    return resourceDefinition;
};

const App = () => (
    <Admin
        customRoutes={customRoutes}
        catchAll={NotFound}
        customReducers={{ theme: themeReducer }}
        dashboard={Dashboard}
        layout={Layout}
        authProvider={authProvider}
        dataProvider={dataProvider}
        i18nProvider={i18nProvider}
        loginPage={Login}
    >
        {(permissions) => {
            const isCoach = permissions?.includes(rolesGlobal.coach);

            return [
                <Resource key="languages" name="languages" />,
                <Resource key="categories" name="categories" {...categories} />,
                <Resource key="background-modules" name="background-modules" {...backgroundModules} />,
                <Resource key="background-playlists" name="background-playlists" {...backgroundPlaylists} />,
                <Resource key="users" name="users" {...users} />,
                
                <Resource key="members" name="members" {...getResourceProps(members, isCoach)} />,
                <Resource key="objectives" name="objectives" {...getResourceProps(objectives, isCoach)} />,
                <Resource key="plans" name="plans" {...getResourceProps(plans, isCoach)} />,
                <Resource key="modules" name="modules" {...getResourceProps(modules, isCoach)} />,
                <Resource key="content-types" name="content-types" {...getResourceProps(contentTypes, isCoach)} />,
                <Resource key="playlists" name="playlists" {...getResourceProps(playlists, isCoach)} />,
                <Resource key="sub-content-types" name="sub-content-types" {...getResourceProps(subContentTypes, isCoach)} />,
                <Resource key="doctors" name="doctors" {...getResourceProps(doctors, isCoach)} />,
                <Resource key="surveys" name="surveys" {...getResourceProps(surveys, isCoach)} />,
                <Resource key="journals" name="journals" {...getResourceProps(journals, isCoach)} />,
                <Resource key="badges" name="badges" {...getResourceProps(badges, isCoach)} />,
                <Resource key="timelines" name="timelines" {...getResourceProps(timelines, isCoach)} />,
				<Resource key="tasks" name="tasks" {...getResourceProps(tasks, isCoach)} />,

                <Resource key="subscriptions" name="subscriptions" {...subscriptions} />,
                <Resource key="user-suggestions" name="user-suggestions" {...userSuggestions} />,
                <Resource key="lists-singles" name="lists-singles" {...listsSingles} />,
                <Resource key="communication-pages" name="communication-pages" {...communicationPages} />,
                <Resource key="communication-flows" name="communication-flows" {...communicationFlows} />,
                <Resource key="promo-codes" name="promo-codes" {...promoCodes} />,
                <Resource key="reminders" name="reminders" {...reminders} />,
                <Resource key="day-portions" name="day-portions" {...dayPortions} />,
                <Resource key="daily-recommendations-ar" name="daily-recommendations-ar" {...dailyRecommendationsArabic} />,
                <Resource key="daily-recommendations-en" name="daily-recommendations-en" {...dailyRecommendationsEnglish} />,
                <Resource key="featured-ar" name="featured-ar" {...featuredArabic} />,
                <Resource key="featured-en" name="featured-en" {...featuredEnglish} />,
                <Resource key="mood-tracker" name="mood-tracker" {...moodTracker} />,
                <Resource key="businesses" name="businesses" {...businesses} />,
                <Resource key="licenses" name="licenses" {...licenses} />,
                <Resource key="hr/resources/categories" name="hr/resources/categories" {...hrResourcesCategories} />,
                <Resource key="hr/resources/content" name="hr/resources/content" {...hrResourcesContent} />,
                <Resource key="web-products" name="web-products" {...products} />,
                <Resource key="demo-requests" name="demo-requests" {...demoRequests} />,
                <Resource key="smsLogs" name="smsLogs" {...smsLogs} />
            ];
        }}
    </Admin>
);

export default App;